import React from "react";
import { Route, Switch } from "react-router-dom";
import HeaderLayoutRoute from "../../Layout/HeaderLayoutRoute";
import Home from "../../Common/Home";
import Signup from "../../Client/Signup";
import TncPage from "../../Common/TncPage";
import Support from "../../Common/Support";
import ArticlePage from "../../Common/Resouces/ArticlePage";
import ArticleDetails from "../../Common/Resouces/ArticleDetails/ArticleDetails";
import VideoPage from "../../Common/Resouces/VideoPage";
import VideoDetail from "../../Common/Resouces/VideoDetails/VideoDetail";
import Resouces from "../../Common/Resouces";
import SearchResult from "../../Common/Resouces/SearchResult";
import { RoutesUrl } from "../constents";
import ExternalTOTP from "../../Common/ExternalTOTP";

const CommonRoutes = () => {
  return (
    <Switch>
      <HeaderLayoutRoute exact path={RoutesUrl.Signup} component={Signup} />
      <HeaderLayoutRoute exact path={RoutesUrl.Home} component={Home} />
      <HeaderLayoutRoute exact path={RoutesUrl.Support} component={Support} />
      <HeaderLayoutRoute exact path={RoutesUrl.Article} component={ArticlePage}/>
      <HeaderLayoutRoute exact path={RoutesUrl.Etotp} component={ExternalTOTP}/>
      <HeaderLayoutRoute
        exact
        path="/articles/:resourceId"
        component={ArticleDetails}
      />
      <HeaderLayoutRoute exact path={RoutesUrl.Videos} component={VideoPage} />
      <HeaderLayoutRoute
        exact
        path="/videos/:resourceId"
        component={VideoDetail}
      />
      <HeaderLayoutRoute exact path={RoutesUrl.Resouces} component={Resouces} />
      <HeaderLayoutRoute
        exact
        path={RoutesUrl.ResoucesSearch}
        component={SearchResult}
      />

      <Route exact path={RoutesUrl.TermsAndConditions} component={TncPage} />
    </Switch>
  );
};

export default CommonRoutes;
